import { RfqService } from '@approot/services/rfq/rfq.service';
import { AdminService } from '@approot/services/admin/admin.service';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-medusa-login',
  templateUrl: './medusa-login.component.html',
  styleUrls: ['./medusa-login.component.scss']
})
export class MedusaLoginComponent {
  @Input() public isModalOpened: boolean;
  public password: string;
  public attemptingToLogin: boolean;

  constructor(
    private adminService: AdminService,
    private rfqService: RfqService
  ) {}

  public login() {
    // when the user tries to login with their password
    this.attemptingToLogin = true;
    const accountCredentials = this.adminService.medusaCredentials.find(
      credential => credential.entity === this.medusaAccount.entity
    );
    this.rfqService
      .logUserIn(
        // attempt to login
        {
          user: accountCredentials.medusaUser,
          password: this.password,
          entity: this.medusaAccount.entity
        }
      )
      .subscribe(
        () => {
          // if login is successful save the password on the hydra back end
          const payload = {
            task: 'updateMedusaPassword',
            medusaUser: accountCredentials.medusaUser,
            password: this.password
          };

          this.attemptingToLogin = false;
          this.adminService.showMedusaLoginErrorModal = false;

          this.rfqService.resetPassword(payload).then(obs => {
            obs.subscribe(() => {
              accountCredentials.password = this.password; // set the password locally
              this.adminService.showMedusaLoginErrorModal = null;
            });
          });
        },
        err => {
          this.attemptingToLogin = false;
        }
      );
  }

  public get medusaAccount() {
    return this.adminService.medusaAccount;
  }

  public get showModal() {
    return this.adminService.showMedusaLoginErrorModal;
  }

  public modalChanged() {
    if (!this.attemptingToLogin) {
      this.rfqService.logout();
    }
    this.adminService.showMedusaLoginErrorModal = false;
  }
}
